import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, InputBase } from '@mui/material';
import { useState } from 'react';

import useStyles from './QuickSearch.styles';

const QuickSearch = ({
  onChange,
  border = false
}: {
  onChange: (term: string) => void;
  border?: boolean;
}) => {
  const { classes } = useStyles({ border });
  const [search, setSearch] = useState<string>('');

  const handleSearchChange = (term: string) => {
    setSearch(term);
    onChange(term);
  };

  return (
    <Box className={`${classes.quickSearch} quickSearch`}>
      <InputBase
        className={classes.searchInput}
        placeholder="Search"
        size="small"
        fullWidth
        value={search}
        onChange={(e) => handleSearchChange(e.target.value)}
        endAdornment={
          search !== '' ? (
            <IconButton
              size="small"
              color="secondary"
              onClick={() => handleSearchChange('')}
            >
              <FontAwesomeIcon
                icon={faTimesCircle}
                className={classes.clearIcon}
              />
            </IconButton>
          ) : (
            <FontAwesomeIcon icon={faSearch} className={classes.searchIcon} />
          )
        }
      />
    </Box>
  );
};

export default QuickSearch;
